import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'

import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import {
  kyrgyzstanRealtyTypesStore,
  kyrgyzstanSearchStore,
} from 'entities/kyrgyzstan/model'

import { FilterBar as SharedFilterBar } from 'shared/ui/filter-bar'
import type { FilterBarItem } from 'shared/ui/filter-bar'

import { getFilterActiveState } from '../lib/get-filter-active-state'
import { getFilterDisplayText } from '../lib/get-filter-display-text'
import { FilterBarItems } from '../model'

export const FilterBar = observer(() => {
  const { t } = useTranslation()

  const { sort, realty_type_ids } = kyrgyzstanSearchStore
  const { realtyTypes, fetchRealtyTypes } = kyrgyzstanRealtyTypesStore

  useEffect(() => {
    void fetchRealtyTypes({
      has_object: true,
    })
  }, [fetchRealtyTypes])

  const activeFilters = getFilterActiveState({
    sort,
    realty_type_ids,
  })

  const displayTexts = getFilterDisplayText({
    sort,
    realty_type_ids,
    realtyTypes,
    t,
  })

  const getIsFilterActive = (filterType: keyof typeof activeFilters) => {
    return activeFilters[filterType]
  }

  const getDisplayText = (
    filterType: keyof typeof displayTexts,
    fallbackTitle: string,
  ) => {
    const isActive = activeFilters[filterType]
    const displayText = displayTexts[filterType]

    if (isActive && displayText) {
      return displayText
    }

    const fallbackTranslations: Record<string, string> = {
      sort: 'kyrgyzstan_block.sort.options.price_asc',
      filters: 'kyrgyzstan_block.filters.type.any',
    }

    return t(fallbackTranslations[fallbackTitle] || fallbackTitle)
  }

  const hasActiveFilters = Object.values(activeFilters).some(Boolean)

  const items: FilterBarItem[] = FilterBarItems.map((item) => {
    const filterType = item.title as keyof typeof activeFilters
    const isActive = getIsFilterActive(filterType)
    const displayText = getDisplayText(filterType, item.title)

    return {
      id: item.title,
      link: item.link,
      text: displayText,
      isActive,
    }
  })

  return (
    <SharedFilterBar
      items={items}
      filterLink={RoutingPaths.kyrgyzstan.filters.path()}
      showBadge={hasActiveFilters}
    />
  )
})
